import React from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import Sobre from './components/Sobre';
import Statistics from './components/Statistics';
import Departments from './components/Departments';
import Jobs from './components/Jobs';
import Banner from './components/Banner';
import InfoModal from './components/InfoModal';
import Apoio from './components/Apoio';
import Team from './components/Team';
import Contacts from './components/Contacts';
import Footer from './components/Footer';
import Credits from './components/Credits';

function App() {
  return (
    <>
      <Header />
      <Hero />
      <Sobre />
      <Statistics />
      <Team />
      <Banner />
      <Departments />
      <Apoio />
      <InfoModal />
      <Jobs />
      <Contacts />
      <Footer />
      <Credits />
    </>
  );
}

export default App;
